import { Outlet, NavLink, useNavigate } from 'react-router-dom'
import { LayoutDashboard, BookOpen, BarChart2, CircleDollarSign, Users, Settings, LogOut, HandHeart } from 'lucide-react'
import { useAuthStore } from '../store/authStore'

const nav = [
  { to: '/',                label: 'Home',          icon: LayoutDashboard, end: true },
  { to: '/library',         label: 'Nudge Library', icon: BookOpen },
  { to: '/analytics',       label: 'Analytics',     icon: BarChart2 },
  { to: '/team',            label: 'Team',          icon: Users },
  { to: '/accountability',  label: 'Buddies',       icon: HandHeart },
  { to: '/pricing',         label: 'Pricing',       icon: CircleDollarSign },
  { to: '/settings',        label: 'Settings',      icon: Settings },
]

export function DashboardLayout() {
  const { user, logout } = useAuthStore()
  const navigate = useNavigate()

  function handleLogout() {
    logout()
    navigate('/login')
  }

  return (
    <div className="flex h-screen overflow-hidden" style={{background: '#F5F2EA', color: '#1a3a40'}}>
      {/* Sidebar */}
      <aside className="w-60 flex flex-col shrink-0" style={{background: '#FDFCF8', borderRight: '1px solid #e0d9cc'}}>
        {/* Logo */}
        <div className="flex items-center gap-2 px-5 py-5" style={{borderBottom: '1px solid #e0d9cc'}}>
          <span className="text-2xl">🕊</span>
          <span className="font-bold text-lg tracking-tight" style={{color: '#1a3a40', fontFamily: 'Georgia, serif'}}>Duva</span>
        </div>

        {/* Nav links */}
        <nav className="flex-1 px-3 py-4 space-y-1">
          {nav.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors"
              style={({ isActive }) => isActive
                ? { background: '#EBF6FB', color: '#2A7A8A' }
                : { color: '#6b8a8f' }
              }
            >
              <Icon size={17} />
              {label}
            </NavLink>
          ))}
        </nav>

        {/* User footer */}
        <div className="px-3 py-4" style={{borderTop: '1px solid #e0d9cc'}}>
          <div className="flex items-center gap-3 px-3 py-2 mb-1">
            <div className="w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold text-white shrink-0" style={{background: '#2A7A8A'}}>
              {user?.name?.[0]?.toUpperCase() ?? '?'}
            </div>
            <div className="min-w-0">
              <p className="text-xs font-medium truncate" style={{color: '#1a3a40'}}>{user?.name}</p>
              <p className="text-xs truncate capitalize" style={{color: '#9aafb3'}}>{user?.role}</p>
            </div>
          </div>
          <button
            onClick={handleLogout}
            className="flex items-center gap-3 px-3 py-2 w-full rounded-lg text-sm transition-colors"
            style={{color: '#9aafb3'}}
            onMouseEnter={e => { e.currentTarget.style.color = '#e05a5a'; e.currentTarget.style.background = '#fdf2f2' }}
            onMouseLeave={e => { e.currentTarget.style.color = '#9aafb3'; e.currentTarget.style.background = 'transparent' }}
          >
            <LogOut size={16} />
            Sign out
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  )
}
